"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carbonia": {
    "7e2a3e7b": [{
      "hkey": "f8d913bf",
      "slug": "carbonia",
      "name": "Carbonia",
      "primary": true,
      "skipSearch": false
    }],
    "is-gannaus": [{
      "hkey": "f8d913bf",
      "slug": "carbonia",
      "name": "Carbonia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5fb94300": [{
      "hkey": "02404976",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "serbariu": [{
      "hkey": "02404976",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "carbonia"
    }]
  }
};
exports["default"] = _default;